import React from 'react';
import EmptyState from '@atlaskit/empty-state';
import { useIntl } from '@atlassian/jira-intl';
import type { Status } from '@atlassian/jira-version-modals/src/common/model/index.tsx';
import imageUrl from './assets/release.svg';
import messages from './messages.tsx';

type Props = {
	statusFilter: Status[];
	searchFilter: string;
};

export function Empty(props: Props) {
	const { formatMessage } = useIntl();

	const { statusFilter, searchFilter } = props;

	return (
		<EmptyState
			imageUrl={imageUrl}
			header={formatMessage(messages.header)}
			description={formatMessage(
				!searchFilter && statusFilter.length > 0
					? messages.noMatchingStatusDescription
					: messages.defaultDescription,
			)}
		/>
	);
}

export default Empty;
